"use client";
import { initGA, trackPageview } from "@/utils/ga";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const GA_ID = process.env.NEXT_PUBLIC_GA_ID;

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  useEffect(() => {
    if (GA_ID) {
      initGA();
      trackPageview(pathname);
    }
  }, [pathname]);

  return <>{children}</>;
}
